// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__U1sp7","name":"ConsentHeader_name__3ZcM3","birthday":"ConsentHeader_birthday__3RuqA","skeleton":"ConsentHeader_skeleton__17znk"};